import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksBillForm.QBooksBillFieldsSection', {
    billDateField: 'Bill date',
    billDatePlaceholder: 'Enter Bill date',
    billNoField: 'Bill number',
    billNumberPlaceholder: 'Enter the Bill number',
    dueDateField: 'Due date',
    dueDatePlaceholder: 'Enter the due date',
    departmentPlaceholder: 'Select {fieldText}',
    termsField: 'Terms',
    termsPlaceholder: 'Enter the terms',
    sectionName: 'Bill details',
    earlyDueDateWarning: 'Due date is earlier than the Date.',
    multipleDepartmentsWarning: 'Qbooks bills included more than one {fieldText} in the past. Check suggested options.',
});
